
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"53.333","height":"53.333","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.873 2.106A13.645 13.645 0 008.211 20.761l10.556 18.273a1.421 1.421 0 00.867.668 1.431 1.431 0 001.609-.667l10.549-18.268a13.663 13.663 0 00-4.919-18.661zm3.912 11.788a10.775 10.775 0 01-1.468 5.434L20 35.464l-9.32-16.141A10.793 10.793 0 0119.981 3.1a10.826 10.826 0 012.767.361 10.786 10.786 0 018.037 10.431z"}}),_c('path',{attrs:{"d":"M20 7.035a6.858 6.858 0 000 13.716 6.858 6.858 0 000-13.716zm0 10.859a4 4 0 114-4 4 4 0 01-4 4z"}})])
          )
        }
      }
    